module.exports = __webpack_public_path__ + "static/media/ordiginal.8b38a7e6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ordiginal.webp
// module id = 664
// module chunks = 0